const DebtType = {
  Month: 'month',
  Total: 'total',
};
export default {
  DebtType,
};
